import React from 'react';
import { Calendar, Clock } from 'lucide-react';

interface EventItem {
    title: string;
    date: string;
    reason?: string;
}

interface UpcomingEventsProps {
    title: string;
    items: EventItem[];
    icon?: React.ReactNode;
}

const UpcomingEvents: React.FC<UpcomingEventsProps> = ({ title, items, icon = <Calendar className="mr-2" size={18} /> }) => (
    <div className="bg-white rounded-lg shadow-md p-4">
        <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
            {icon}
            {title}
        </h3>
        {items.length === 0 ? (
            <p className="text-gray-500 text-sm">No hay eventos próximos</p>
            ) : (
                <ul className="space-y-2">
                    {items.map((item, index) => (
                    <li key={index} className="flex items-start border-b border-gray-100 pb-2">
                        <div className="bg-blue-100 text-blue-800 rounded-full p-1 mr-2">
                            <Clock size={16} />
                        </div>
                        <div>
                            <p className="font-medium text-sm">{item.title}</p>
                            <p className="text-xs text-gray-600">{item.date}</p>
                            {item.reason && <p className="text-xs text-gray-500 italic">{item.reason}</p>}
                        </div>
                    </li>
                    ))}
                </ul>
            )
        }
    </div>
);

export default UpcomingEvents;